// @flow
/**
 * @file Shows the polling results in a strip with different colors and an
 * indication where 50% is.
 *
 * Created by km on 2017-01-12.
 */

import * as React from 'react'
import './styles.scss'
import config from 'config'
import { interpolateRgbBasis, quantize } from 'd3-interpolate'

const colors = quantize(
  interpolateRgbBasis(['#1D5F82', '#FFE2C7', '#A67A00']),
  7
)

function PollingStrip (props: {
  priceRanges: [number, number, number, number, number, number, number],
  summedPriceRanges: [number, number, number, number, number, number, number]
}) {
  let boxes = props.priceRanges.map((quota, index) => {
    return (
      <rect
        x={index > 0 ? props.summedPriceRanges[index - 1] * 100 : 0}
        y={0}
        width={quota * 100}
        height='100%'
        key={`quota-${index}`}
        style={{
          fill: colors[index]
        }}
      />
    )
  })

  const sortedPriceRanges = props.priceRanges.slice().sort((a, b) => b - a)
  const indexOfLargestPart = props.priceRanges.indexOf(sortedPriceRanges[0])
  const leftPosition =
    ((indexOfLargestPart === 0
      ? 0
      : props.summedPriceRanges[indexOfLargestPart - 1]) +
      props.summedPriceRanges[indexOfLargestPart]) /
    2 *
    100

  return (
    <div className='polling-strip'>
      <svg
        className='strip'
        viewBox='0 0 100 10'
        preserveAspectRatio='none'
        style={{ width: '100%' }}
      >
        {boxes}
      </svg>
      <div className='legend-strip'>
        <div style={{ left: `${leftPosition}%` }}>
          {props.summedPriceRanges[6] > 0
            ? config.priceRangeBrackets[indexOfLargestPart]
            : ''}
        </div>
      </div>
    </div>
  )
}

export default PollingStrip
